import { TCreateSubcategoryModalAction, CreateSubcategoryModalActionTypes } from '../createSubcategoryModalActions';
import { ICreateSubcategoryModalState } from './createSubcategoryModalContext';

export const createSubcategoryModalReducer = (
	state: ICreateSubcategoryModalState,
	action: TCreateSubcategoryModalAction,
): ICreateSubcategoryModalState => {
	switch (action.type) {
		case CreateSubcategoryModalActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateSubcategoryModalActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateSubcategoryModalActionTypes.CHANGE_NAME_OF_SUBCATEGORY:
			return {
				...state,
				nameOfSubCategory: action.payload.nameOfSubCategory,
			};
		case CreateSubcategoryModalActionTypes.SET_ID_SELECTED_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
			};
		case CreateSubcategoryModalActionTypes.CHANGE_SUBCATEGORY_VISIBILITY_STATUS:
			return {
				...state,
				isHiddenSubCategory: action.payload.isHiddenSubCategory,
			};
		case CreateSubcategoryModalActionTypes.CHANGE_AVAILABLE_FOR_REPETITION:
			return {
				...state,
				isAvailableForRepetition: action.payload.isAvailableForRepetition,
			};
		case CreateSubcategoryModalActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateSubcategoryModalActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateSubcategoryModalActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateSubcategoryModalActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateSubcategoryModalActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateSubcategoryModalActionTypes.INITIAL_DATA:
			return {
				...state,
				IDCustomer: action.payload.IDCustomer,
				IDRestaurant: action.payload.IDRestaurant,
				fileId: null,
				nameOfSubCategory: '',
				IDSelectedCategory: null,
				isHiddenSubCategory: false,
				isAvailableForRepetition: false,
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		default:
			return state;
	}
};
